module.exports = __webpack_public_path__ + "img/living_3.28c7d6fb.jpg";